import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { logout } from '../slice/authSlice';
import { all_routes } from '../../../feature-module/router/all_routes';

interface RejectedActionPayload {
    status: number;
    data: {
        [key: string]: unknown;
    };
    error: string;
}

// Error logger middleware
export const rtkQueryErrorLogger: Middleware =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (api: MiddlewareAPI) => next => (action: any) => {
        const routes = all_routes;
        // Prevent handling the logout action itself
        if (action.type === 'auth/logout') {
            return next(action);
        }

        // Check if the action is a rejected action from an RTK query
        if (isRejectedWithValue(action)) {
            const payload = action.payload as RejectedActionPayload;
            const { status } = payload;

            // Only dispatch logout for 401 errors that aren't from auth endpoints
            if (status === 401 && !action.meta?.arg?.endpointName?.includes('login')) {
                api.dispatch(logout());
            }
            if(status === 403)
            {
                window.location.pathname = routes.error401;
                return;
            }
            if(status === 500)
            {
                // window.location.pathname = routes.error500;
                // return;
            }

            console.error('RTK Query Error:', payload.status);
            console.log(payload.error);
        }

        return next(action);
    };